export default __webpack_public_path__ + "static/media/verification.253d25b0.svg";